<template>
    <div class="login">
        <div class="login_img">
            <h1>喜乐司机端</h1>
        </div>
        <div class="login_form">
            <div>
                <span>手机号:</span>
                <input @blur="springback" v-model="mobile" style="border:none;" type="tel" placeholder="请输入手机号">
                <span class="obtain"></span>
            </div>
            <div>
                <span>验证码:</span>
                <input @blur="springback" v-model="code" type="tel" placeholder="请输入验证码">
                <span class="obtain" id="obtain_bt">{{btntxt}}</span>
            </div>
        </div>
        <div class="refer">
            <p>
                <input type="checkbox" checked>
                <span>我已经同意《加油服务协议》</span>
            </p>
            <div @click="submit" :class="[( mobile.trim().length>0) && (code.trim().length>0)  ? 'btn-green' : '' ]">
                登录
            </div>
        </div>
    </div>
</template>

<script>
    import {verify} from "../../static/gt"
    import common from "../common";

    export default {
        name: 'login',
        data() {
            return {
                login_bol: false,
                submit_bol: false,
                mobile: "",
                code: "",
                time: 0,
                btntxt: "获取验证码",
                ban: false,
                challenge_val: "",
                validate_val: "",
                seccode_val: "",
                openid: ""
            }
        },
        methods: {
            //验证手机号码部分
            validation() {
                const {mobile} = this;
                const reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
                if (!mobile) {
                    common.toast("请输入手机号");
                } else if (!reg.test(mobile)) {
                    common.toast('手机号格式不正确');
                } else if (this.time > 0) {
                    common.toast("请在" + this.time + "秒后重试");
                } else {
                    return true;
                }
            },
            sendcode() {
                //发送验证码
                const {mobile} = this;
                let challenge_val = this.challenge_val;
                let validate_val = this.validate_val;
                let seccode_val = this.seccode_val;
                const type = "wxlogin";
                this.disabled = true;
                let querystring = require('querystring');
                this.$api.post("/wx/sendCode",
                    querystring.stringify({
                        mobile,
                        type,
                        challenge_val,
                        validate_val,
                        seccode_val
                    })
                ).then(data => {
                    if (data.data.status == 0) {
                        common.toast(data.data.msg);
                    } else {
                        this.time = 60;
                        this.timer();
                        common.toast("发送成功");
                    }
                }).catch(err => {
                    console.log(err);
                })
            },
            timer() {
                if (this.time > 0) {
                    this.time--;
                    this.btntxt = this.time + "s";
                    this.ban = true;
                    setTimeout(this.timer, 1000);
                } else {
                    this.ban = false;
                    this.time = 0;
                    this.btntxt = "获取验证码";
                }
            },
            submit() {
                if (this.code) {
                    let querystring = require('querystring');
                    this.$api.post('/wx/login',
                        querystring.stringify({
                            mobile: this.mobile,
                            code: this.code,
                            openid: this.openid
                        })
                    ).then(({data}) => {
                        if (data.status == 1) {
                            common.setlocalStorage("userInfo", JSON.stringify(data.data));
                            this.$router.replace("/");
                        } else {
                            common.toast(data.msg);
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                } else {
                    common.toast("验证码不能为空");
                }
            },
            // 解决苹果不回弹页面
            blurAdjust(e) {
                setTimeout(() => {
                    if (document.activeElement.tagName == 'INPUT' || document.activeElement.tagName == 'TEXTAREA') {
                        return
                    }
                    let result = 'pc';
                    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
                        result = 'ios'
                    } else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
                        result = 'android'
                    }

                    if (result = 'ios') {
                        document.activeElement.scrollIntoViewIfNeeded(true);
                    }
                }, 100)
            },
            //处理ioc编辑input框后,页面不弹回原来的样式;
            springback() {
                let u = navigator.userAgent, app = navigator.appVersion
                let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                if (isIOS) {
                    this.blurAdjust();
                }
            },
            handler() {
                event.preventDefault();// 阻止默认的处理方式(阻止下拉滑动的效果)
            }
        },
        created() {
            this.openid = this.$route.query.openid || "";
            verify(window);
            let this_ = this;
            this_.$api.get('/GeetestStart').then(data => {
                initGeetest({
                    // 以下配置参数来自服务端 SDK
                    gt: data.data.gt,
                    challenge: data.data.challenge,
                    offline: !data.data.success,
                    new_captcha: true,
                    product: 'bind'
                }, function (captchaObj) {
                    captchaObj.onReady(() => {
                    })
                        .onSuccess(() => {
                            let result = captchaObj.getValidate();
                            if (!result) {
                                return alert('请完成验证');
                            }
                            this_.challenge_val = result.geetest_challenge;
                            this_.validate_val = result.geetest_validate;
                            this_.seccode_val = result.geetest_validate;
                            this_.sendcode();
                        })
                    document.querySelector("#obtain_bt").onclick = function () {
                        if (this_.validation()) {
                            captchaObj.verify(); //显示验证码
                        }
                    }
                })
            }).catch((err) => {
                common.toast(err);
            })
        },
        mounted() {
            // 绑定事件
            document.addEventListener('touchmove', this.handler, {passive: false});// passive 参数不能省略，用来兼容ios和android
        },
        destroyed() {
            // 解绑事件
            document.removeEventListener('touchmove', this.handler, {passive: false});
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .login {
        width: 100vw;
        min-height: 100vh;
        background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 20px;
        box-sizing: border-box;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
        padding-bottom: constant(safe-area-inset-bottom);
        padding-bottom: env(safe-area-inset-bottom);
    }

    .login_img {
        width: 100%;
        margin-bottom: 40px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .login_img > h1 {
        font-size: 28px;
        font-weight: 800;
        color: #106EBE;
        letter-spacing: 2px;
        text-shadow: 0 4px 10px rgba(16, 110, 190, 0.2);
        margin: 0;
    }

    .login_img > img {
        margin: 3vh auto;
        width: auto;
        height: 25vh;
    }

    .login_form {
        width: 100%;
        max-width: 340px;
        background: rgba(255, 255, 255, 0.9);
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        border-radius: 20px;
        padding: 30px 20px;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
        display: flex;
        flex-direction: column;
        gap: 16px;
        box-sizing: border-box;
    }

    .login_form > div {
        width: 100%;
        display: flex;
        align-items: center;
        background: #f8f9fa;
        border-radius: 12px;
        padding: 0 16px;
        height: 54px;
        border: 1px solid transparent;
        transition: all 0.3s ease;
        box-sizing: border-box;
    }

    .login_form > div:focus-within {
        background: white;
        border-color: #106EBE;
        box-shadow: 0 0 0 4px rgba(16, 110, 190, 0.1);
    }

    .login_form > div > span:first-child {
        font-size: 14px;
        color: #666;
        font-weight: 600;
        width: 65px;
        flex-shrink: 0;
    }

    .obtain {
        color: #106EBE;
        font-size: 13px;
        font-weight: 600;
        padding-left: 10px;
        border-left: 1px solid #eee;
        white-space: nowrap;
    }

    .login_form input {
        flex: 1;
        outline: none;
        font-size: 16px; /* Prevents auto-zoom on iOS */
        color: #333;
        border: none;
        background: transparent;
        height: 100%;
        width: 100%;
    }

    .login_form input::-webkit-input-placeholder {
        color: #adb5bd;
    }

    .refer {
        width: 100%;
        max-width: 340px;
        margin-top: 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
    }

    .refer p {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        font-size: 13px;
        color: #666;
        margin-bottom: 24px;
    }

    .refer input[type="checkbox"] {
        width: 16px;
        height: 16px;
        accent-color: #106EBE;
    }

    .refer div {
        width: 100%;
        height: 50px;
        background: #dee2e6;
        line-height: 50px;
        border-radius: 14px;
        color: white;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        cursor: pointer;
    }

    .refer .btn-green {
        background: linear-gradient(135deg, #106EBE 0%, #005a9e 100%);
        box-shadow: 0 4px 15px rgba(16, 110, 190, 0.3);
    }

    .refer .btn-green:active {
        transform: translateY(2px);
        box-shadow: 0 2px 10px rgba(16, 110, 190, 0.2);
    }

    .mint-toast-text {
        font-size: .6rem;
    }

    .addClass {
        padding: 20px !important;
    }

    .addClass > span {
        padding-top: 0 !important;
    }
</style>
      


// WEBPACK FOOTER //
// src/components/login.vue